import React from 'react';
import './consent-uploader.scss';

const ConsentHeader = ({ title, description }) => {
    return (
        <>
            <h2>{title}</h2>
            <p className="consent-header-description">{description}</p>
            <hr className="consent-header-line"></hr>
        </>
    );
};

export default ConsentHeader;
